let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Asrt")).then(() => parcelRequire('9Vj9G'));